<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <SelectInput
        v-model="searchValue"
        style="margin: 20px"
        :value="null"
      />

      <el-input-number
        placeholder="开始时间"
        v-model="beginTimeMin"
        controls-position="right"
        :min="0"
        :max="999999"
        size="small"
        style="margin-right: 20px;width: 120px"
      ></el-input-number>

      <el-input-number
        placeholder="结束时间"
        v-model="endTimeMin"
        controls-position="right"
        :min="0"
        :max="999999"
        size="small"
        style="margin-right: 20px;width: 120px"
      ></el-input-number>
      <el-select
        v-model="value"
        placeholder="请选择"
        size="small"
        style="width: 100px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="statusValue"
        placeholder="请选择"
        size="small"
        style="width: 100px; margin-left:20px"
      >
        <el-option
          v-for="item in status"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getOfflineReport()"
      >查询</el-button>

      <!-- <el-button
        style="margin-left: auto"
        size="small"
        @click="exportOfflineReport()"
      >导出</el-button> -->
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        :data="tableData"
        border
        stripe
        max-height="100%"
        height="100%"
        style="min-width: 100%"
        row-key="vehicleId"
        size="mini"
        ref="table"
      >
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="bmsNo"
          label="电池编号"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="bmsType"
          label="电池类型"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="bmsTime"
          label="最后Bms时间"
          align="center"
          min-width="150"
        />
        <el-table-column
          prop="gpsTime"
          label="最后终端时间"
          align="center"
          min-width="150"
        />
        <!-- <el-table-column
          prop="vehicleType"
          label="车辆型号"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <TypeSelect
              :value="scope.row.vehicleType"
              type="vehicleType"
              :text="true"
            />
          </template>
        </el-table-column>-->
        <el-table-column
          prop="groupName"
          label="组织名称"
          align="center"
          min-width="150"
        />
        <el-table-column
          prop="speed"
          label="位置"
          min-width="300"
          align="center"
        >
          <template slot-scope="scope">{{scope.row.address}}</template>
        </el-table-column>
        <el-table-column
          prop="spaceTime"
          label="时间范围"
          min-width="120"
          align="center"
        />
        <el-table-column
          label="状态"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">{{statusFormat(scope.row.status)}}</template>
        </el-table-column>
        <el-table-column
          prop="terminalNo"
          label="设备编号"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="terminalType"
          label="设备类型"
          align="center"
          min-width="150"

        />
        <el-table-column
          label="详情"
          width="80"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getAll(scope.row)"
            >查看详情</el-button>
          </template>
        </el-table-column>

        <el-table-column
          label="地图"
          width="80"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.disabled"
              @click="showMap(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->

      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getOfflineReport"
        @current-change="getOfflineReport"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->

      <BatteryDataDialog
        :visible.sync="batteryVisible"
        :batteryData.sync="batteryData"
        :type.sync="batteryType"
      />
    </div>
    <div
      slot="plugins"
      class="map"
    >
      <el-dialog
        width="700px"
        :visible="dialogTableVisible"
        @close="dialogTableVisible = false"
      >
        <MapDialog
          :coordinate="coordinate"
          :address="address"
          :vehicleType="vehicleType"
        />
      </el-dialog>
    </div>
  </ManageBox>
</template>

<script>
import ManageBox from "@/components/ManageBox/index.vue";
import SelectInput from "@/components/SelectInput/index.vue";
import MapDialog from "@/components/MapDialog/index.vue";
import BatteryDataDialog from "@/components/BatteryDataDialog/index.vue";
import { mapState } from 'vuex';

export default {
  components: {
    ManageBox,
    SelectInput,
    MapDialog,
    BatteryDataDialog
  },
  data() {
    return {
      loading: false,
      batteryVisible: false,
      batteryData: null,
      batteryType: "",
      coordinate: {},
      vehicleType: null,
      address: null,
      value: 1,
      statusValue: -2,
      options: [
        {
          value: 1,
          label: "天"
        },
        {
          value: 2,
          label: "小时"
        },
        {
          value: 3,
          label: "分钟"
        }
      ],
      status: [
        {
          value: -2,
          label: "全部"
        },
        {
          value: -1,
          label: "从未上线"
        },
        {
          value: 0,
          label: "离线"
        },
        {
          value: 1,
          label: "休眠"
        },
        {
          value: 2,
          label: "在线"
        }
      ],
      place: null,
      beginTimeMin: 1,
      endTimeMin: 7,
      //   ruleForm: {
      //     beginTimeMin: null,
      //     endTimeMin: null
      //   },
      //   rules: {
      //     beginTimeMin: [
      //       { required: true, message: "请输入开始分钟", trigger: "blur" },
      //       { pattern: /^[0-9]{1,}$/, message: "请输入正确分钟", trigger: "blur" }
      //     ],
      //     endTimeMin: [
      //       { required: true, message: "请输入结束分钟", trigger: "blur" },
      //       { pattern: /^[0-9]{1,}$/, message: "请输入正确分钟", trigger: "blur" }
      //     ]
      //   },
      searchValue: null,
      model: "", //当前查询型号
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0,
      dialogTableVisible: false
    };
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      console.log("scrollllllllll");
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
    this.getOfflineReport();
  },
  computed:{
      ...mapState(['USER']),
  },
  methods: {
    async  getMonitorInfo(oid,vid){
        await this.$API.getMonitorInfo({
            organizationId: veh.organizationId,
            vehicleId: veh.vehicleId
        })
    },
    statusFormat(data) {
      return data === -1
        ? "从未上线"
        : data === 0
        ? "离线"
        : data === 1
        ? "休眠"
        : data === 2
        ? "在线"
        : "--";
    },
    //获取电池所有信息
    async getAll(mydata) {
        console.log(mydata)
      //if (!mydata || mydata.vehicleId === null) return;
      // const options = [
      //   "GPRS-XINGHENG",
      //   "GPRS-BETTER",
      //   "GPRS-PEICHENG"
      // ];
      const fn = {
        XINGHENG: "getXINGHENG",
        BETTER: "getBETTER",
        PEICHENG: "getPEICHENG",
        DALI: "getDALI",
        HERCULES: "getHERCULES",
      };
      this.batteryType = mydata.terminalType.split("-")[1];
      if(mydata.terminalType == 'GPRS-DALI' || mydata.terminalType == "GPRS-HERCULES" || mydata.terminalType == "LD-01A" || mydata.terminalType == "GPRS-SUNWODA"){
            let self = this;
            await this.$API.getMonitorInfo({
                organizationId: mydata.groupId,
                vehicleId: mydata.vehicleId,
            }).then(res=>{
                this.selectMonitorInfo = res.data;
                let data = {alarm:{},analog:{}}
                function generateName(o,name){
                    let obj = [];
                    for(let item in self.selectMonitorInfo[o]){
                        obj.push({title:item,value:self.selectMonitorInfo[o][item]});
                    }
                    return obj;
                }
                //告警量
                data.alarm.errorStatus = generateName('errorStatus','alarm.errorStatus');
                data.alarm.protectStatus = generateName('protectStatus','alarm.protectStatus');
                data.alarm.systemStatus = generateName('systemStatus','alarm.systemStatus');
                data.alarm.warnStatus = generateName('warnStatus','alarm.warnStatus');
                data.baseInfo = generateName('baseInfo','alarm.baseInfo');
                data.analog.salveTempList = this.selectMonitorInfo.salveTempList?this.selectMonitorInfo.salveTempList:[];
                //模拟量
                data.analog.mapList = this.selectMonitorInfo.mapList?this.selectMonitorInfo.mapList.map((item)=>{return item.coreVoltage;}):[];
                data.analog.tempList = this.selectMonitorInfo.tempList?this.selectMonitorInfo.tempList:[];
                this.batteryData = data;
                data = {alarm:{},analog:{}};
            })
        }else{
            const { data } = await this[fn[mydata.terminalType.split("-")[1]]](mydata.vehicleId);
            this.batteryData = data;
        }
        this.batteryVisible = true;
    },
    async getPEICHENG() {
      console.log("getPEICHENG");
    },
    async getBETTER(vehicleId) {
      return await this.$API.getMockPileWarnPileInfoBetter({
        vehicleId: vehicleId
      });
    },
    async getXINGHENG(vehicleId) {
      return await this.$API.getMockPileWarnPileInfo({
        vehicleId: vehicleId
      });
    },
    // async getDALI(vehicleId) {
    //   return await this.$API.getMockPileWarnPileInfo({
    //     vehicleId: vehicleId
    //   });
    // },
    // async getHERCULES(vehicleId) {
    //   return await this.$API.getMockPileWarnPileInfo({
    //     vehicleId: vehicleId
    //   });
    // },
    showMap(row) {
      this.dialogTableVisible = true;
      this.coordinate = {
        lat: row.lat,
        lon: row.lon
      };
      this.address = row.address;
      this.vehicleType = row.status;
      //this.coordinate = [row.lat, row.lon, row.address, row.vehicleType];
    },

    timeTomin() {
      if (this.endTimeMin <= this.beginTimeMin) {
        this.$msg({
          message: "结束时间必须大于开始时间！",
          type: "error"
        });
      }
      this.beginTimeMin =
        this.beginTimeMin === undefined ? 0 : this.beginTimeMin;
      this.endTimeMin = this.endTimeMin === undefined ? 1 : this.endTimeMin;
    },
    //导出离线报表
    // async exportOfflineReport() {
    //   this.timeTomin();
    //   if (!this.tableData.length) {
    //     this.$msg({
    //       showClose: true,
    //       message: "无可导出的数据",
    //       type: "warning"
    //     });
    //     return;
    //   }
    //   try {
    //     this.$API.exportOfflineReport(this.getParams);
    //   } catch (error) {
    //     console.error(error);
    //     this.$msg({
    //       showClose: true,
    //       message: error.msg,
    //       type: "error"
    //     });
    //   }
    // },
    //获取离线报表数据
    async getOfflineReport() {
      this.timeTomin();
      this.loading = true;
      let params = {
        beginOffTimeMin:
          this.value === 1
            ? this.beginTimeMin * 24 * 60
            : this.value === 2
            ? this.beginTimeMin * 60
            : this.beginTimeMin || 0,
        endOffTimeMin:
          this.value === 1
            ? this.endTimeMin * 24 * 60
            : this.value === 2
            ? this.endTimeMin * 60
            : this.endTimeMin || 999999,
        status: this.statusValue,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if (this.searchValue === null || this.searchValue === "") {
        params.flag = 0;
        params.chooseId = 0;
        params.groupId = 0;
      } else if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("organizationId")
      ) {
        params.flag = 2;
        params.chooseId = 0;
        params.groupId = this.searchValue.organizationId;
      } else if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("vehicleId")
      ) {
        params.chooseId = this.searchValue.vehicleId;
        params.flag = 1;
        params.groupId = this.searchValue.groupId;
      }
      this.getParams = params;
      // const { organizationId, vehicleId } = this.searchValue;
      try {
        const { data, total } = await this.$API.getOnOfflineReport(params);
        this.total = total;
        const addressList = await this.$API.GetGeo(data);
        addressList.map(({ address, tag }) => {
          data[tag].address = address;
          data[tag].disabled = address === "获取位置失败" ? true : false;
        });
        this.tableData = data.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
// ::v-deep.el-input {
//   width: 100px !important;
//   margin-left: 20px !important;
// }
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
.map {
  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-icon-close {
    position: relative;
    z-index: 999;
    background-color: rgb(80, 80, 80);
    border-radius: 50%;
    display: flex;
    color: #fff;
    justify-content: center;
    align-items: center;
    padding: 2px;
    &:hover {
      color: red;
    }
  }
}
</style>
